import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_FOLKSONOMY_TOPICS = defineFcm('enable_folksonomy_topics')
	.asBoolean()
	.withDefault(false)
	.toConfig();
